<template>
  <div class="box1">
    <img src="../../../assets/coursePage/mba/box1/img01.png"/>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {
     
    };
  },
  computed: {
    
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;

  width: 100%;
  height:464px;
  background: url("../../../assets/coursePage/mba/box1/banner.png") no-repeat;
  background-size: cover;
  background-position: center;
  padding-top: 100px;
  box-sizing: border-box;
  img{
    width: 562px;
   display: block;
    margin: 0 auto;
  }
  
}
</style>
